import fetch from '@/utils/fetch'
import constants from '@/utils/constants'

// 登录
export const login = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/auth/login',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 获取用户信息
export const getInfo = () => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/auth/info',
    method: 'post'
  })
}
// 退出登录
export const logout = () => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/auth/logout',
    method: 'post'
  })
}

// 验证码
export const captcha = (params: any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/captcha',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 编辑用户信息
export const editUser = (params: any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organize/auth/edit',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 忘记密码
export const forgetPassword = (params: any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/forgetPassword',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 重置密码
export const resetPassword = (params: any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/resetPassword',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 验证码验证
export const validateCaptcha = (params: any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/validate',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 验证密码
export const validatePassword = (params: any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/validatePassword',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 验证密码
export const bindPhone = (params: any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/bindPhone',
    method: 'post',
    data: {
      ...params
    }
  })
}
// 获取未待办列表
export const getUnhandler = (params: any) => {
  return fetch({
    url: constants.API_MODULE_PATH.MESSAGE + '/organize/web/campusMessage/list',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 登录第一步：查询关联园所和机构
export const organizeLoginVos = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/organizeLoginVos',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 登录第二步：选择机构/园所，正式登录
export const authLogin = (params:any) => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/login',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 机构用户详情
export const organizeUserInfo = () => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/info',
    method: 'post'
  })
}

// 登出
export const organizeLogout = () => {
  return fetch({
    url: constants.API_MODULE_PATH.ORGANIZE + '/organization/auth/logout',
    method: 'post'
  })
}
